import { useAtom } from 'jotai';
import React, { useEffect, useRef } from 'react';
import mStar from '../assets/img/m-star.png'; // 이미지 import
import { languageAtom } from '../atoms/languageAtom';

const Contact = () => {
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const [language] = useAtom(languageAtom);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          } else {
            entry.target.classList.remove('show');
          }
        }
      },
      {
        threshold: 0.1,
      }
    );

    // title 관찰
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }

    // desc items 관찰
    if (descRef.current) {
      const items = descRef.current.children;
      for (const item of Array.from(items)) {
        if (item) {
          observer.observe(item);
        }
      }
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="contact" data-section="contact">
      <div className="contact__inner">
        <h2 className="contact__title" ref={titleRef}>
          Contact
        </h2>
        <div className="contact__desc" ref={descRef}>
          {language !== 'en' ? (
            <div className="contact__desc__item">
              <b className="contact__desc__item__text kr">찾아오시는 길</b>
              <b className="contact__desc__item__text kr">
                모수 레스토랑 : 서울시 용산구 회나무로 41길 4
              </b>
              <b className="contact__desc__item__text kr">
                *입구에서 발렛 서비스가 가능합니다
              </b>
              <a
                className={'menu text-link'}
                rel="noreferrer"
                href="https://maps.app.goo.gl/S21PqC2XTf1ifuKJA"
                target="_blank"
                title="Open the Map"
              >
                * Open Map
              </a>
            </div>
          ) : (
            <div className="contact__desc__item">
              <b>Address</b>
              <b>
                Restaurant address : 4, Hoenamu-ro 41-gil, Yongsan-gu, Seoul,
                Korea
              </b>
              <b>Valet service is available at the entrance.</b>
              <a
                className={'menu text-link'}
                rel="noreferrer"
                href="https://maps.app.goo.gl/S21PqC2XTf1ifuKJA"
                target="_blank"
                title="Open the Map"
              >
                * Open Map
              </a>
            </div>
          )}

          <div className="contact__desc__item">
            <b>Contact</b>
            <b>contact@mosuseoul.com</b>
          </div>

          <div className="contact__desc__item">
            <b>*Accolades*</b>
            <b className="contact__desc__item__text kr">
              Michelin Guide Korea 2025-2026
              <img src={mStar} alt="star" />
              <img src={mStar} alt="star" />
            </b>
            <b className="contact__desc__item__text kr">
              Michelin Guide Korea 2023-2024
              <img src={mStar} alt="star" />
              <img src={mStar} alt="star" />
              <img src={mStar} alt="star" />
            </b>
            <b className="contact__desc__item__text kr">
              Asia's 50 Best Restaurants 2024 - Chef's Choice Award
            </b>
            <b className="contact__desc__item__text kr">
              Asia's 50 Best Restaurants 2023 - Best Restaurant in Korea
            </b>
            <b className="contact__desc__item__text kr">
              Opinionated About Dining 2021-2024 - Best Restaurant in Korea
            </b>
            <b className="contact__desc__item__text kr">
              Taste of Seoul 2022-2023 - Best Restaurant in Seoul
            </b>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
